var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm3.6,5.9-4,4a1,1,0,0,1-.7.3,1,1,0,0,1-.71-.3L3.4,8.07A1,1,0,0,1,4.82,6.65l.92.93a.29.29,0,0,0,.18.07.26.26,0,0,0,.17-.07L9.18,4.49a1,1,0,0,1,1.42,0A1,1,0,0,1,10.6,5.9Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccess);
export default __webpack_public_path__ + "static/media/status-success.0135944cbf9754d44dc4cde8abb20bcd.svg";
export { ForwardRef as ReactComponent };